export const TimelineConstants = {
  POPULATE_TIMELINES: 'LOAD_TIMELINES_FROM_CHRONICLE',

  CREATE_REQUEST: 'TIMELINE_CREATE_REQUEST',
  CREATE_SUCCESS: 'TIMELINE_CREATE_SUCCESS',
  CREATE_FAILURE: 'TIMELINE_CREATE_FAILURE',

  UPDATE_REQUEST: 'TIMELINE_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'TIMELINE_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'TIMELINE_UPDATE_FAILURE',

  DELETE_REQUEST: 'TIMELINE_DELETE_REQUEST',
  DELETE_SUCCESS: 'TIMELINE_DELETE_SUCCESS',
  DELETE_FAILURE: 'TIMELINE_DELETE_FAILURE',
};
